export default __webpack_public_path__ + "static/green-dots-reviews-9d6806d9b6ddb0e98b278d2b0a54628f.svg";